/**
 * Float-comparison tolerance shared by the sport-allocation components —
 * "fully allocated" (BulkSportAllocationModal's Unallocated gate) and
 * "under-allocated" (EventTagCell's amber warning) both need the same
 * epsilon so the two views can never disagree about whether a split is
 * complete. Mirrors the backend's own 0.01 sum-to-100 / sum-to-totalQty
 * tolerance (SportAllocationController::ALLOCATION_TOLERANCE).
 */
export const ALLOCATION_EPSILON = 0.01;
